import { z } from 'zod/v4'
import { postSchema } from '@/types/schema/api/radar-search-post'

export const postResponseSchema = postSchema

export type FetchPostResponse = z.infer<typeof postResponseSchema>
